import React from "react"
import styled, {createGlobalStyle, ThemeProvider} from "styled-components"
import globalTheme from "../constants/theme"
import {makeFontStack} from "../helpers/fontStack"
import {Boundary} from "./Boundary"
import {Header} from "./Header"

const Body = (props) => {
  const hasFooter = !!props.footerRenderer
  const hasSideBar = !!props.sideBarRenderer

  const MainContent = (
    <Main
      hasBoundary={props.hasBoundary}
      hasHeader={props.hasHeader}
      hasSideBar={hasSideBar}
    >
      {props.children}
    </Main>
  )
  return (
    <ThemeProvider theme={globalTheme}>
      <ThemeProvider theme={props.theme}>
        <GlobalStyle hasHeader={props.hasHeader} />
        {props.hasBoundary ? <Boundary>{MainContent}</Boundary> : MainContent}
        {props.hasHeader && (
          <Header
            {...props.header}
            hasBoundary={props.hasBoundary}
            hasSideBar={hasSideBar}
            links={props.headerLinks}
            title={props.title}
            titleLink={props.titleLink}
          />
        )}
        {hasSideBar && (
          <SideBarDiv style={props.sideBarStyle}>
            {props.sideBarRenderer()}
          </SideBarDiv>
        )}
        {hasFooter && props.footerRenderer()}
      </ThemeProvider>
    </ThemeProvider>
  )
}

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: ${(props) => props.theme.boxSizing};
  }
  a {
    color: inherit;
    &:hover {
      text-decoration: none;
    }
  }
  body {
    background-color: ${(props) => props.theme.backgroundColor};
    color: ${(props) => props.theme.textColorDark};
    font-family: ${(props) => makeFontStack(props.theme.fontFamily)};
    font-feature-settings: "kern", "liga", "clig", "calt";
    font-kerning: normal;
    font-size: ${(props) => props.theme.fontSizeMedium}px;
    margin: 0;
    padding-top: ${(props) =>
      props.hasHeader ? props.theme.headerHeight : 0}px;
    word-wrap: break-word;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: rgba(0, 0, 0, 0.875);
    text-rendering: optimizeLegibility;
  }
  html {
    font-family: sans-serif;
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
  }
  img {
    display: block;
  }
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }
`

const Main = styled.main`
  min-height: ${(props) =>
    `calc(100vh${props.hasHeader ? ` - ${props.theme.headerHeight}px` : ""})`};
  margin-left: ${(props) =>
    props.hasSideBar ? props.theme.sideBarWidth : 0}px;
`

const SideBarDiv = styled.div`
  bottom: 0;
  position: fixed;
  top: 0;
  width: ${(props) => props.theme.sideBarWidth}px;
`

Body.defaultProps = {
  hasBoundary: false,
  hasHeader: false,
  theme: {},
}

export {Body}
